import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchCraftDesignsApi,
  addCraftDesignApi,
  updateCraftDesignApi,
  deleteCraftDesignApi,
} from "../services/CraftDesignService";

// Fetch craft designs
export const fetchCraftDesigns = createAsyncThunk(
  "craftDesigns/fetchCraftDesigns",
  async (searchText = "", { rejectWithValue }) => {
    try {
      const designs = await fetchCraftDesignsApi(searchText);
      return designs;
    } catch (err) {
      return rejectWithValue(err?.message || "Failed to fetch designs");
    }
  }
);

// Add craft design
export const addCraftDesign = createAsyncThunk(
  "craftDesigns/addCraftDesign",
  async (designData, { dispatch }) => {
    const res = await addCraftDesignApi(designData);
    dispatch(fetchCraftDesigns(""));
    return res;
  }
);

// Update craft design
export const updateCraftDesign = createAsyncThunk(
  "craftDesigns/updateCraftDesign",
  async (designData, { dispatch }) => {
    const res = await updateCraftDesignApi(designData);
    dispatch(fetchCraftDesigns(""));
    return res;
  }
);

// Delete craft design
export const deleteCraftDesign = createAsyncThunk(
  "craftDesigns/deleteCraftDesign",
  async (id, { dispatch }) => {
    const res = await deleteCraftDesignApi(id);
    dispatch(fetchCraftDesigns(""));
    return id;
  }
);

const craftDesignSlice = createSlice({
  name: "craftDesigns",
  initialState: {
    designs: [],
    selectedDesign: null,
    status: "idle",
    error: null,
  },
  reducers: {
    setSelectedDesign: (state, action) => {
      state.selectedDesign = action.payload;
    },
    clearSelectedDesign: (state) => {
      state.selectedDesign = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCraftDesigns.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchCraftDesigns.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.designs = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchCraftDesigns.rejected, (state, action) => {
        state.status = "failed";
        state.designs = [];
        state.error = action.error.message;
      });
  },
});

export const { setSelectedDesign, clearSelectedDesign } = craftDesignSlice.actions;
export default craftDesignSlice.reducer;
